<template>
  <div class="statistics-container">
    <div class="statistics-header">
      <h2>数据统计</h2>
      <div class="operation-buttons">
        <el-button type="primary" @click="exportData" icon="el-icon-download">导出数据</el-button>
<!--        <el-upload-->
<!--            action=""-->
<!--            :auto-upload="false"-->
<!--            :on-change="importData"-->
<!--            :show-file-list="false"-->
<!--            accept=".json,.csv,.xlsx"-->
<!--            styles="display: inline-block; margin-left: 10px;"-->
<!--        >-->
<!--          <el-button type="success" icon="el-icon-upload2">导入数据</el-button>-->
<!--        </el-upload>-->
      </div>
    </div>

    <el-row :gutter="20" class="chart-row">
      <el-col :xs="24" :sm="24" :lg="12">
        <div class="chart-container">
          <div class="chart-title">月度销售额趋势</div>
          <div ref="salesChart" class="chart"></div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="12">
        <div class="chart-container">
          <div class="chart-title">产品销量占比</div>
          <div ref="productChart" class="chart"></div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="chart-row">
      <el-col :xs="24" :sm="24" :lg="12">
        <div class="chart-container">
          <div class="chart-title">用户增长趋势</div>
          <div ref="userChart" class="chart"></div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="12">
        <div class="chart-container">
          <div class="chart-title">地区销售分布</div>
          <div ref="regionChart" class="chart"></div>
        </div>
      </el-col>
    </el-row>

    <div class="data-table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="date" label="日期" width="180"></el-table-column>
        <el-table-column prop="sales" label="销售额(元)"></el-table-column>
        <el-table-column prop="orders" label="订单数"></el-table-column>
        <el-table-column prop="users" label="新增用户"></el-table-column>
        <el-table-column prop="conversion" label="转化率(%)"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import chinaMap from '@/assets/map/china.json' // 自定义路径

// 注册地图数据
echarts.registerMap('china', chinaMap)

export default {
  name: 'StatisticsView',
  data() {
    return {
      salesChart: null,
      productChart: null,
      userChart: null,
      regionChart: null,
      tableData: [
        { date: '2023-01', sales: 12500, orders: 156, users: 42, conversion: 3.2 },
        { date: '2023-02', sales: 14320, orders: 179, users: 51, conversion: 3.5 },
        { date: '2023-03', sales: 16890, orders: 211, users: 63, conversion: 3.7 },
        { date: '2023-04', sales: 15230, orders: 190, users: 57, conversion: 3.6 },
        { date: '2023-05', sales: 18970, orders: 237, users: 71, conversion: 3.8 },
        { date: '2023-06', sales: 21050, orders: 263, users: 79, conversion: 3.9 },
        { date: '2023-07', sales: 23410, orders: 293, users: 88, conversion: 4.1 }
      ],
      chartData: {
        sales: {
          months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月'],
          values: [12500, 14320, 16890, 15230, 18970, 21050, 23410]
        },
        products: [
          { name: '产品A', value: 35 },
          { name: '产品B', value: 25 },
          { name: '产品C', value: 20 },
          { name: '产品D', value: 15 },
          { name: '产品E', value: 5 }
        ],
        users: {
          months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月'],
          values: [42, 51, 63, 57, 71, 79, 88]
        },
        regions: [
          { name: '华东', value: 45 },
          { name: '华北', value: 25 },
          { name: '华南', value: 20 },
          { name: '西部', value: 10 }
        ]
      }
    }
  },
  mounted() {
    this.initCharts()
    window.addEventListener('resize', this.resizeCharts)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCharts)
    if (this.salesChart) this.salesChart.dispose()
    if (this.productChart) this.productChart.dispose()
    if (this.userChart) this.userChart.dispose()
    if (this.regionChart) this.regionChart.dispose()
  },
  methods: {
    initCharts() {
      this.initSalesChart()
      this.initProductChart()
      this.initUserChart()
      this.initRegionChart()
    },
    resizeCharts() {
      if (this.salesChart) this.salesChart.resize()
      if (this.productChart) this.productChart.resize()
      if (this.userChart) this.userChart.resize()
      if (this.regionChart) this.regionChart.resize()
    },
    initSalesChart() {
      this.salesChart = echarts.init(this.$refs.salesChart)
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: '{b}<br/>销售额: {c}元'
        },
        xAxis: {
          type: 'category',
          data: this.chartData.sales.months
        },
        yAxis: {
          type: 'value',
          name: '销售额(元)'
        },
        series: [{
          data: this.chartData.sales.values,
          type: 'line',
          smooth: true,
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(58, 77, 233, 0.8)' },
              { offset: 1, color: 'rgba(58, 77, 233, 0.1)' }
            ])
          },
          itemStyle: {
            color: '#3a4de9'
          },
          lineStyle: {
            width: 3
          }
        }]
      }
      this.salesChart.setOption(option)
    },
    initProductChart() {
      this.productChart = echarts.init(this.$refs.productChart)
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          data: this.chartData.products.map(item => item.name)
        },
        series: [
          {
            name: '销量占比',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: this.chartData.products
          }
        ]
      }
      this.productChart.setOption(option)
    },
    initUserChart() {
      this.userChart = echarts.init(this.$refs.userChart)
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: '{b}<br/>新增用户: {c}人'
        },
        xAxis: {
          type: 'category',
          data: this.chartData.users.months
        },
        yAxis: {
          type: 'value',
          name: '用户数(人)'
        },
        series: [{
          data: this.chartData.users.values,
          type: 'bar',
          barWidth: '40%',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#83bff6' },
              { offset: 0.5, color: '#188df0' },
              { offset: 1, color: '#188df0' }
            ])
          },
          emphasis: {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#2378f7' },
                { offset: 0.7, color: '#2378f7' },
                { offset: 1, color: '#83bff6' }
              ])
            }
          }
        }]
      }
      this.userChart.setOption(option)
    },
    initRegionChart() {
      this.regionChart = echarts.init(this.$refs.regionChart)
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c}%'
        },
        visualMap: {
          min: 0,
          max: 50,
          text: ['高', '低'],
          realtime: false,
          calculable: true,
          inRange: {
            color: ['#50a3ba', '#eac736', '#d94e5d']
          }
        },
        series: [
          {
            name: '销售分布',
            type: 'map',
            map: 'china',
            emphasis: {
              label: {
                show: true
              }
            },
            data: [
              { name: '北京', value: 15 },
              { name: '天津', value: 10 },
              { name: '上海', value: 25 },
              { name: '重庆', value: 8 },
              { name: '河北', value: 12 },
              { name: '河南', value: 18 },
              { name: '云南', value: 6 },
              { name: '辽宁', value: 9 },
              { name: '黑龙江', value: 5 },
              { name: '湖南', value: 14 },
              { name: '安徽', value: 11 },
              { name: '山东', value: 20 },
              { name: '新疆', value: 3 },
              { name: '江苏', value: 22 },
              { name: '浙江', value: 23 },
              { name: '江西', value: 10 },
              { name: '湖北', value: 13 },
              { name: '广西', value: 8 },
              { name: '甘肃', value: 5 },
              { name: '山西', value: 7 },
              { name: '内蒙古', value: 4 },
              { name: '陕西', value: 9 },
              { name: '吉林', value: 6 },
              { name: '福建', value: 15 },
              { name: '贵州', value: 7 },
              { name: '广东', value: 28 },
              { name: '青海', value: 2 },
              { name: '西藏', value: 1 },
              { name: '四川', value: 16 },
              { name: '宁夏', value: 3 },
              { name: '海南', value: 5 }
            ]
          }
        ]
      }
      this.regionChart.setOption(option)
    },
    exportData() {
      // const tHeader = ['日期', '销售额(元)', '订单数', '新增用户', '转化率(%)']
      // const filterVal = ['date', 'sales', 'orders', 'users', 'conversion']
      // const data = this.formatJson(filterVal, this.tableData)
      // exportJsonToExcel(tHeader, data, '销售数据统计')
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    importData(file) {
      const fileType = file.name.split('.').pop().toLowerCase()
      const reader = new FileReader()

      reader.onload = (e) => {
        try {
          if (fileType === 'json') {
            const data = JSON.parse(e.target.result)
            this.$message.success('数据导入成功')
            console.log('导入的数据:', data)
            // 这里可以添加数据处理逻辑，更新图表数据
          } else if (fileType === 'csv') {
            // 处理CSV文件
            const csvData = e.target.result
            const lines = csvData.split('\n')
            const result = []
            const headers = lines[0].split(',')

            for (let i = 1; i < lines.length; i++) {
              if (!lines[i]) continue
              const obj = {}
              const currentline = lines[i].split(',')

              for (let j = 0; j < headers.length; j++) {
                obj[headers[j]] = currentline[j]
              }
              result.push(obj)
            }

            this.$message.success('CSV数据导入成功')
            console.log('导入的CSV数据:', result)
          } else {
            this.$message.warning('暂不支持该文件格式')
          }
        } catch (error) {
          this.$message.error('文件解析失败: ' + error.message)
        }
      }

      if (fileType === 'json' || fileType === 'csv') {
        reader.readAsText(file.raw)
      } else {
        this.$message.warning('请上传JSON或CSV格式文件')
      }
    }
  }
}
</script>

<style scoped>
.statistics-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.statistics-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.chart-row {
  margin-bottom: 20px;
}

.chart-container {
  padding: 15px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.chart-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.chart {
  width: 100%;
  height: 350px;
}

.data-table {
  margin-top: 20px;
}

@media (max-width: 768px) {
  .chart {
    height: 250px;
  }

  .statistics-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .operation-buttons {
    margin-top: 10px;
  }
}
</style>